import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
import GenericListTabHistory from "./../../factories/generic-list-tab-history";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItemNetworkTab extends GenericListTabHistory {
    ConfigurationItem: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 1000;
        this.ConfigurationItem = parent;
    }
    ControllerUrl = "ConfigurationItemNetworkTab";
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default ConfigurationItemNetworkTab;